import { fallLeagueRegistraion, notes, teams, evaluations, kto2, threetoFour, games, coaches, sportsmanship, gym, uniforms, why, goldstar} from './ThreeVThreeLeagueData'
import PurchaseList from '../../components/PurchaseList';
import Location from '../../components/Location.jsx'
import LogisiticsDetails from '../../components/LogisiticsDetails';
import 'animate.css';

export default function ThreeVThree() {
  return (
    <section className="section d-flex flex-column align-items-center justify-content-center">
      <div className="info camps__container animate__animated animate__fadeInRight">
        <h4>Gold Star 3 on 3 Co-Ed Basketball League March to May</h4>
        <div className='camp__container'>
          <div className="purchase">
          <LogisiticsDetails 
              header="100% of our profits will be donated to Gold Star Famiies"
              data={goldstar}
            />
            <PurchaseList 
              type="bundle"
              header="Skills, Practice, Games"
              subhead="All In One Day"
              data={fallLeagueRegistraion}
            />
            <LogisiticsDetails 
              header="Important Notes"
              data={notes}
            />
              <LogisiticsDetails 
              header="Mini Madness K to 2nd"
              data={kto2}
            />
            <br/>
               <LogisiticsDetails 
              header="Not So Mini 3rd to 4th"
              data={threetoFour}
            />
            <LogisiticsDetails 
              header="Coaches"
              data={coaches}
            />
               <LogisiticsDetails 
              header="Gym"
              data={gym}
            />
          </div>        
          <div className='logistics'>
          <LogisiticsDetails 
              header="Why 606 Academy"
              data={why}
            />
          <Location 
            link="https://maps.app.goo.gl/bzJQMCjncGWaXhTH6"
            name="Lotus Elementary School"
            street="29067 W Grass Lake Rd"
            city=" Fox Lake, IL 60020"
          />
            <LogisiticsDetails 
              header="The League"
              data={teams}
            />
             <LogisiticsDetails 
              header="Evaluations"
              data={evaluations}
            />
               <LogisiticsDetails 
              header="Games"
              data={games}
            />
                <LogisiticsDetails 
              header="Uniforms"
              data={uniforms}
            />
                <LogisiticsDetails 
              header="Sportsmanship"
              data={sportsmanship}
            />
          </div>
          {/* close logistics div */}
        </div>
        {/* close camp container */}
      </div>
      {/* close info div */}
    </section>
  )
}